/* eslint-disable react-hooks/exhaustive-deps */
import { CloseIcon, ProfileWorkerInfoIcon } from "assets";
import { FooterMaximized } from "components/footer";
import Header from "components/headerfull";
import { HoverButton2 } from "components/ui/Buttons/OutlineCopy";
import Form from "components/ui/Forms";
import Input, { WOSInput } from "components/ui/Forms/Input";
import Select from "components/ui/Forms/Select";
import TextArea from "components/ui/Forms/TextArea";
import FileUpload from "components/ui/Forms/Upload";
import { countries } from "constants/index";
import { Field, FieldArray, FormikProvider, useField, useFormik, useFormikContext } from "formik";
import { useSafeField } from "hooks/useSafeField";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { profilWorkerSchema } from "schemas";
import { _getDomains, _getFreelanceStatus, _getCurrencies, _getLangs, _getProfileWorker, _getSkills, _updateProfileWorker } from "services/parcours/freelance.service";
import { requestInfos } from "store";



const files:any = {};

export const Settings = ({data}:any)=>{


    const history= useNavigate();
    const [requestInfosAtom, setRequestInfosAtom] = useRecoilState(requestInfos)

    const formik:any = useFormik({
        initialValues:{
            profile:"",
            civilite: "",
            prenom: "",
            nom: "",
            email: "",
            telephone: "",
            dateNaissance: "",
            lieuNaissance: "",
            nomUtilisateur: "",
            adresseComplete: "",
            codePostal: "",
            ville: "",
            pays: "",
            devise: "", 
            prix1: "",
            prix2: "",
            domaineInfo:[
                {
                    domaine: "", 
                    competences: [{
                        nom:"",
                        experience: "",
                        niveau: "",
                    }], 
                    
                }
            ],
            domaineFavori: "", 
            langues: [], 
            adresseDomicile: "", 
            adresseProIdentique: true, 
            adresseProDifferente: false, 
            justificatifIdentite: null,
            justificatifDomicile: null,
            cv: null, 
            nomSociete: "",
            adresseSiege: "",
            numeroIdentification: "", 
            certificatImmatriculation: null, 
            justificatifIdentiteDirigeant: null,
            audioPresentation: null, 
            presentation: "",
            attestation: null,
            rib: null, 
            documentsComplementaires: null,
            autorisationLogo: false, 
            certificationAuthenticite: false
        },
        validationSchema: profilWorkerSchema,
        validateOnBlur:false,
        validateOnChange: false,
        onSubmit: async (values:any, actions)=>{

            try {

                const formPayload = new FormData();
                const documents = ['documentsComplementaires', 'rib', 'justificatifIdentite', 'justificatifDomicile', 'cv', 'attestation','justificatifIdentiteDirigeant', 'audioPresentation']
                Object.keys(values).forEach((key) => {
                    if (values[key] !== null && values[key] !== undefined) {
                        if (documents.includes(key)) {
                            formPayload.append(key, values[key]?.file);
                        } else {
                            console.log({e:values?.domaineInfo})
                            if(key === "langues") formPayload.append(key, JSON.stringify(values[key].map((el:any)=>el.id)))
                            else if(key === "domaineInfo"){
                                formPayload.append(key, JSON.stringify(values[key].map((el:any)=>({[el.domaine.id]:el.competences.map((el:any)=>({nom_competence:el.nom.value, skillId:el.nom.id,anneeExperience: `${el.experience}`, niveau: el?.niveau}))}))))
                            }else if(key === "devise"){
                                formPayload.append(key,values[key]?.value)
                            }
                            else if(["statut", "domaineFavoris"].includes(key)){
                                formPayload.append(key, values[key]?.id)
                            }else{
                                formPayload.append(key, values[key]);
                            }
                        }
                    }
                });

                
                let res = await _updateProfileWorker(formPayload, {headers:{'Content-Type': 'multipart/form-data'}})
                
                console.log({formPayload, res})
                setRequestInfosAtom({
                    ...requestInfosAtom,
                    success:{
                        message: 'Mise a jour de profil' as any,
                        description: res.message,
                        backToLogin:false
                    }
                })

                setTimeout(()=>{
                    history(`/merci`)
                },0)
    
                console.log({res})
                console.log({values})
                
            } catch (error) {
                console.log({error})
            }
        }
    })

    const {handleSubmit, errors,values}:any = formik;

    console.log({errors})



    const getProfileWorker = async ()=>{
        try {

            console.log("good",formik.setValues)

            if (!data?.form_datas || !formik?.setValues) {
                console.warn("Missing data or formik instance");
                return;
            }


            for (const key in data.form_datas) {

                const value = data.form_datas[key];

                if (
                    typeof value === 'object' &&
                    value !== null &&
                    'url' in value &&
                    'name' in value
                ) {
                    files[key] = value;
                }

            }

            const formData= {
                profile:data.form_datas.profile,
                civilite: data.form_datas.civilite,
                prenom: data.form_datas.prenom,
                nom: data.form_datas.nom,
                email: data.form_datas.email,
                telephone: data.form_datas.telephone,
                dateNaissance: data.form_datas.dateNaissance,
                lieuNaissance:  data.form_datas.lieuNaissance,
                nomUtilisateur:  data.form_datas.nomUtilisateur,
                adresseComplete:  data.form_datas.adresseComplete,
                codePostal:  data.codePostal,
                statut: data.form_datas.status_ids.map((el:any)=>el.id === data.form_datas.status_id?{label: el.name, value:el.name, id:el.id}:null).filter((el:any)=>el !== null).pop() || null,
                ville:  data.form_datas.ville,
                pays:  data.form_datas.country,
                devise:  data.form_datas.devise, 
                prix1:  data.form_datas.prix? data.form_datas.prix : "" ,
                prix2:  "",
                domaineInfo: data.form_datas.domaineInfo.length?  data.form_datas.domaineInfo.map((el:any)=>({
                    domaine: {label:el.category_id?.name, value:el.category_id?.name, id: el.category_id?.id},
                    competences: el?.competences.map((competence:any)=>({
                        nom: {label:competence.competence_id?.name,value:competence.competence_id?.name,id:competence.competence_id?.id},
                        experience: competence.experience  || "",
                        niveau: competence?.niveau,
                    }))
                })): [
                    {
                        domaine: "", 
                        competences: [{
                            nom:"",
                            experience: "",
                            niveau: "",
                        }], 
                        
                    }
                ],
                domaineFavoris: {...data.form_datas.domaineFavori, label: data.form_datas.domaineFavori.name, value:data.form_datas.domaineFavori.name}, 
                langues: data.form_datas.langues.map((el:any)=>({label:el.name, value: el.name, id:el.id})), 
                adresseDomicile: data.form_datas.adresseDomicile, 
                adresseProIdentique: data.form_datas.adresseProIdentique, 
                adresseProDifferente: data.form_datas.adresseProDifferente, 
                justificatifIdentite: null,
                justificatifDomicile: null,
                cv: null, 
                nomSociete: data.form_datas.nomSociete,
                adresseSiege: data.form_datas.adresseSiege,
                numeroIdentification: data.form_datas.numeroIdentification, 
                certificatImmatriculation: null, //data.form_datas.certificatImmatriculation, 
                justificatifIdentiteDirigeant: null, //data.form_datas.justificatifIdentiteDirigeant ,
                // audioPresentation: data.form_datas.audioPresentation.pop(), 
                presentation: data.form_datas.presentation,
                attestation: null, //data.form_datas.attestation,
                rib: null,//data.form_datas.rib, 
                documentsComplementaires: null, //data.form_datas.documentsComplementaires,
                autorisationLogo: true, 
                certificationAuthenticite: true
            }
            console.log({formData})
            formik.setValues(formData)
            console.log({data})
        } catch (error) {
            console.log({error})
        }
    }


    useEffect(() => {
    if (data?.form_datas) {
        getProfileWorker();
    }
    }, [data])
    return (
        <div className="">

            <FormikProvider value={formik}>
                <Form onSubmit={handleSubmit}>

                    <ProfileSettings />
                    
                    <Divider />

                    <Status />

                    <div>
                        
                        <Divider />

                        <Tarif />

                        <Divider />

                        <Parcours />
                        
                        <Divider />
                        
                        <DocumentATransmettre />

                        <div className="mt-[30px]">
                            <HoverButton2 className="font-dm-sans text-[15px] h-[50px] items-center" type="submit" isLoading={formik.isSubmitting} text="Mettre à jour mes informations" />
                        </div>

                    </div>

                </Form>

            </FormikProvider>
            
        </div>
    )
}




export default function ProfilWorker(){

    const components = {
        'profile': <Profile />,
        'settings': <Settings />
    }

    const [componentName, setComponentName]= useState('profile')

    return (
        <div>
            <Header type="default" />
            <Banner />
            <div className="md:px-[9.375rem] px-[25px] py-[3.75rem] font-dm-sans text-[#1D1D39] bg-[#F4F4F5]">
                {/* info bloc */}
                <div className="bg-[#BBBBC4]/20 px-[40px] text-[12px] py-[30px] md:pl-[3.75rem] md:pt-[2.906rem] md:pb-[2.906rem] md:pr-[3.75rem] md:flex items-center  rounded-[0.625rem]">
                    <img src={ProfileWorkerInfoIcon} alt="profile worker info icon " />
                    <p className="md:ml-[1.25rem] font-medium md:text-[1rem] mt-[10px] md:mt-auto ">Votre fiche d’information est incomplète, si vous souhaitez pouvoir retirer l’argent de votre E-Wallet après avoir réalisé des missions, il est indispensable de remplir votre fiche complètement et de transmettre tous les documents demandés. Rendez-vous dans l’onglet Paramètres</p>
                </div>

                {/* main bloc */}
                <div className="flex flex-col sm:flex-row items-start mt-[3.688rem] md:space-x-[1.25rem]">
                    <div className="h-[53.25rem] bg-white w-full md:w-[23.625rem] rounded-[0.625rem]">
                        {/* A Remplir */}
                    </div>
                    {/* <div className="w-full h-auto bg-white rounded-[0.625rem] md:px-[2.625rem] md:pt-[2.438rem] md:pb-[3.063rem] mt-[21px] md:mt-0 p-[21px] ">
                        <div className="flex space-x-8  md:text-[1.25rem] font-bricolage-grotesque mb-[30px]">
                            <button className={componentName === 'profile' ? "font-semibold": "font-semibold text-[#BBBBC4] "} onClick={()=>setComponentName('profile')}>Aperçu du profil</button>
                            <button className={componentName === "settings" ? "font-semibold":"font-semibold text-[#BBBBC4]"} onClick={()=>setComponentName('settings')}>Paramètres</button>
                        </div>

                        <Divider />

                        {(components as any)[componentName]}
                    </div> */}
                    <MainContent />
                </div>
            </div>

            <FooterMaximized />
        </div>
    )
}

const MainContent= () => {
    const components = {
        'profile': <Profile />,
        'settings': <Settings />
    };

    const [componentName, setComponentName] = useState('profile');
    return <>
        <div className="w-full h-auto bg-white rounded-[0.625rem] md:px-[2.625rem] md:pt-[2.438rem] md:pb-[3.063rem] mt-[21px] md:mt-0 p-[21px] ">
            <div className="flex space-x-8  md:text-[1.25rem] font-bricolage-grotesque mb-[30px]">
                <button className={componentName === 'profile' ? "font-semibold" : "font-semibold text-[#BBBBC4] "} onClick={() => setComponentName('profile')}>Aperçu du profil</button>
                <button className={componentName === "settings" ? "font-semibold" : "font-semibold text-[#BBBBC4]"} onClick={() => setComponentName('settings')}>Paramètres</button>
            </div>

            {/* divider */}
            <Divider />

            {(components as any)[componentName]}
        </div>
    </>;
};

const Banner = () => {
    return <>
        <div className="w-full  md:h-[16rem] relative bg-cover bg-center bg-norepeat flex items-center justify-center" style={{ backgroundImage: `url('/profil-worker-banner.png')` }}>
            <div className="md:text-[4rem] text-[40px] font-semibold text-center font-bricolage-grotesque text-white">Mon profil <span className='text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 border-2 border-transparent p-[2px]'>worker</span></div>
        </div>
    </>;
};

const Profile = ()=>{
    return (
        <>
            <div>
                <div className="font-semibold text-[20px] text-[#1D1D39] mb-[20px]">Description</div>
                <div className="font-dm-sans text-[#6F6F6F] mb-[40px]">
                    Lorem ipsum dolor sit amet consectetur. Ornare nulla fusce risus pellentesque faucibus ut faucibus felis. Quam risus semper pellentesque sit pharetra magna phasellus euismod. Donec pharetra auctor etiam in eget a adipiscing. Magna senectus eget vel arcu donec hac. Praesent urna laoreet vitae risus enim vitae diam interdum. Vestibulum sapien aliquet scelerisque tristique tempor viverra turpis. Tortor pellentesque aliquet enim massa sit lorem enim consectetur. Tristique accumsan posuere mi ultricies suspendisse. Tellus magna vulputate lacus tempor pellentesque aliquet.
                </div>

                <div>
                    <div className="font-bricolage-grotesque font-semibold text-[20px] mb-[20px]">Compétences</div>

                    <div className="h-[93px] w-[471.67px] flex   space-x-[20px] my-[10px]">
                        <div className="relative w-[25px]  before:absolute before:content-['']   before:border before:border-[#F4F4F5] before:transform before:left-1/2 before:top-[33px] before:h-[60px]">
                            <div className="h-[25px] rounded-full bg-[#F4F4F5] text-[#1D1D39] flex justify-center items-center">I</div>
                        </div>
                        <div className="font-bricolage-grotesque text-[#6F6F6F] font-normal">
                            <div className="text-primary-blue font-medium text-[18px] leading-[1] mb-[13px]" style={{fontFeatureSettings: '"cpsp" 1'}}>Informatique</div>
                            <div className=" mb-[13px]">Expérience : 8 ans</div>
                            <div className="">Niveau : </div>
                        </div>
                    </div>

                    <div className="h-[93px] w-[471.67px] flex   space-x-[20px] my-[10px]">
                        <div className="relative w-[25px]  before:absolute before:content-['']   before:border before:border-[#F4F4F5] before:transform before:left-1/2 before:top-[33px] before:h-[60px]">
                            <div className="h-[25px] rounded-full bg-[#F4F4F5] text-[#1D1D39] flex justify-center items-center">D</div>
                        </div>
                        <div className="font-bricolage-grotesque text-[#6F6F6F] font-normal">
                            <div className="text-primary-blue font-medium text-[18px] leading-[1] mb-[13px]" style={{fontFeatureSettings: '"cpsp" 1'}}>Développeur web</div>
                            <div className=" mb-[13px]">Expérience : 8 ans</div>
                            <div className="">Niveau : </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const ChangeProfileButton = ({onClick}:any)=>{
    return (
        <div className="flex h-[215px] justify-center items-center" onClick={onClick}>
            <button type="button" className="bg-[#1D1D39] font-dm-sans text-[12px] font-semibold  w-[157px] h-[32px] text-white rounded-[80px] flex  items-center justify-center">
                <div className="">Changer ma photo</div>
                <img src="/change_circle.png" alt="" className="ml-2" />
            </button>
        </div>
    )
}

export const Divider =()=><div className="border-b mb-[30px] border-[#F4F4F5]" />

const Level = ({name,onChange}:any)=>{
    // bg-[#895EF6]
    const [niveau, setNiveau]= useState([1,2,3,4])
    const [field, meta] = useSafeField(name)
    const [selectedLevel,setSelectedLevel] = useState(0)
    

    const handleClick = (e:any)=>{
        if(e.target.id){
            // setSelectedLevel(parseInt(e.target.id,10))
            onChange({
                target:{
                    name,
                    value:e.target.id
                }
            })
        }

    }


    useEffect(()=>{
        console.log({meta, field})
        setSelectedLevel(parseInt(field?.value,10))
    }, [field.value])

    console.log(selectedLevel)
    return (
        <>
            <div className="h-[50px] rounded-full bg-[#F4F4F5] w-full py-[19px] justify-center  flex space-x-[7px]" onMouseMove={handleClick}>
                {
                    niveau.map((el:any)=>{
                        return (
                            <div id={el} className={`h-[12px] w-[12px] ${selectedLevel >= el && selectedLevel!==0 ?'bg-[#895EF6]':'bg-[#895EF633]'} rounded-full`}></div>
                        )
                    })
                }
                {/* <div className="h-[12px] w-[12px] bg-[#895EF633]  rounded-full"></div>
                <div className="h-[12px] w-[12px] bg-[#895EF633]  rounded-full"></div>
                <div className="h-[12px] w-[12px] bg-[#895EF633]  rounded-full"></div>
                <div className="h-[12px] w-[12px] bg-[#895EF633]  rounded-full"></div> */}
            </div>
        </>
    )
}


const ParticularStatus = ()=>{
    const {handleChange, values, errors}:any= useFormikContext()
    return (
        <>
            <div>
                {/* <div className="mb-[30px]">
                    <Form.Item className='' name="adresseDomicile" onChange={handleChange} labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" label="Adresse professionnelle">
                        <Input type="text" className="!bg-[#F4F4F5] text-[15px] !m-auto" inputClassName="placeholder:text-[15px] placeholder:text-[#6F6F6F80]" placeholder="Entrez votre adresse professionnelle" />
                    </Form.Item>
                </div>

                <div   className="mb-[30px]" >
                    <Form.Item className='' onChange={handleChange} name="numeroIdentification" labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" label="Numéro d’identification de la société">
                        <Input type="text" className="!bg-[#F4F4F5] text-[15px] !m-auto" inputClassName="placeholder:text-[15px] placeholder:text-[#6F6F6F80]" placeholder="Entrez le numéro d’identification de la société" />
                    </Form.Item>
                </div> */}

                {/* <div className="md:flex md:space-x-[30px] mb-[30px]">
                    <Form.Item className='flex flex-row-reverse justify-end items-start gap-x-2 md:w-[315px] mb-[30px] md:mb-0' onChange={handleChange} labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] inline-block mt-[.9rem]" name="adresseProIdentique" label="Mon adresse professionnelle est identique à mon adresse personnelle">
                        <Input type="checkbox" className="!h-auto"/>
                    </Form.Item>
                    <Form.Item className='flex flex-row-reverse justify-end items-center gap-x-2 ' name="adresseProDifferente" onChange={handleChange} labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] inline-block " label="Mon adresse professionnelle est différente">
                        <Input type="checkbox" className="!h-auto"/>
                    </Form.Item>
                </div> */}

                <div className="mb-[30px]">
                    <Form.Item className=''  name="justificatifIdentite" onChange={handleChange} labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" label="Justificatif d'identité en cours de validité">
                        {
                            ({field}:any)=> (
                                <div>
                                    <div className={`bg-red-400 rounded-full ring-2 ring-primary-blue`}> 
                                        <FileUpload {...field} className="!bg-[#F4F4F5] text-[15px]" inputClassName="!bg-white !h-[45px] !m-0 w-full md:w-auto " placeholderClassName="hidden md:block md:ml-4" accept="images/*" placeholder={values.justificatifIdentite?.name || "Insérez le justificatif d'identité"} />  
                                    </div>  
                                </div>  
                            )
                        }
                        
                    </Form.Item>
                    {
                        files['justificatifIdentite']?.name &&
                        (
                            <div className=" h-[2rem]  text-primary-blue text-sm flex items-center my-2 space-x-4">
                                <a href={files['justificatifIdentite']?.url} className="!bg-[#eee] rounded-xl flex px-4 relative space-x-2">{files['justificatifIdentite']?.name} <span className="bg-primary-blue hidden text-white absolute -top-2 -right-1 text-xs rounded-full h-4 w-4  cursor-pointer items-center justify-center">x</span> </a>
                            </div>
                        )
                    }
                </div>
                <div className="mb-[30px]">
                    <Form.Item className='' name="justificatifDomicile" onChange={handleChange} labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block " label={
                    <div>
                        <div className="text-[14px] font-dm-sans">Justification de domicile </div>
                        <span className="block text-[12px] font-dm-sans">de - de 3 mois (facture de fluide ou d’abonnement, quittance de loyer, etc.)</span>
                    </div>
                    }>
                        {
                            ({field}:any)=> (
                                <div>
                                    <div className={` rounded-full ring-2 ring-primary-blue`}>
                                        <FileUpload {...field}  className="!bg-[#F4F4F5] text-[15px]" inputClassName="!bg-white !h-[45px] !m-0 w-full md:w-auto " placeholderClassName="hidden md:block md:ml-4"  accept="images/*" placeholder={values.justificatifDomicile?.name || "Insérez le justificatif de domicile"}/>  
                                    </div>
                                </div>  
                            )
                        }
                    </Form.Item>
                    {
                        files['justificatifDomicile']?.name &&
                        (
                            <div className=" h-[2rem]  text-primary-blue text-sm flex items-center my-2 space-x-4">
                                <a href={files['justificatifDomicile']?.url} className="!bg-[#eee] rounded-xl flex px-4 relative space-x-2">{files['justificatifDomicile']?.name} <span className="bg-primary-blue hidden text-white absolute -top-2 -right-1 text-xs rounded-full h-4 w-4  cursor-pointer items-center justify-center">x</span> </a>
                            </div>
                        )
                    }
                </div>
                <div className="mb-[30px]">
                    <Form.Item className='' name="cv" onChange={handleChange} labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" label="Un curriculum vitae">
                        {
                            ({field}:any)=>(
                                <div>
                                    <div className={`bg-red-400 rounded-full `}>
                                        <FileUpload {...field} className="!bg-[#F4F4F5] text-[15px]" inputClassName="!bg-white !h-[45px] !m-0 w-full md:w-auto " placeholderClassName="hidden md:block md:ml-4"  accept="images/*" placeholder={values.cv?.name || values.cv || "Insérez votre CV"}/> 
                                    </div>
                                </div>  
                            )
                        }
                    </Form.Item>
                </div>
            </div>
        </>
    )
    
}


const ProfessionalStatus = ()=>{
    const {handleChange, values, errors}:any= useFormikContext()

    const customHandleChange = (choice:any)=>{
        if(choice === 1){
            handleChange({
                target:{
                    name: 'adresseProIdentique',
                    value:true
                }
            })

            handleChange({
                target:{
                    name: 'adresseProDifferente',
                    value: false
                }
            })
        }else{
            handleChange({
                target:{
                    name: 'adresseProIdentique',
                    value: false
                }
            })

            handleChange({
                target:{
                    name: 'adresseProDifferente',
                    value: true
                }
            })
        }
    }

    
    return (
        <>
            {/* <div className="grid md:grid-cols-2 gap-x-[20px] gap-y-[30px] mb-[30px]">
                <div className="">
                    <Form.Item className='' onChange={handleChange} name="nomSociete" labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" label="Nom de la société">
                        <Input type="text" className="!bg-[#F4F4F5] text-[15px] !m-auto" inputClassName="placeholder:text-[15px] placeholder:text-[#6F6F6F80]" placeholder="Entrez le nom de votre société" />
                    </Form.Item>
                </div>
                <div className="">
                    <Form.Item className='' onChange={handleChange} name="adresseSiege" labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" label="Adresse du siège social">
                        <Input type="text" className="!bg-[#F4F4F5] text-[15px] !m-auto" inputClassName="placeholder:text-[15px] placeholder:text-[#6F6F6F80]" placeholder="Entrez votre adresse du siège social" />
                    </Form.Item>
                </div>
            </div> */}


            <div>
                
                <div className="mb-[30px]">
                    <Form.Item className='' onChange={handleChange} name="nomSociete" labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" label="Nom de la société">
                        <Input type="text" className="!bg-[#F4F4F5] text-[15px] !m-auto" inputClassName="placeholder:text-[15px] placeholder:text-[#6F6F6F80]" placeholder="Entrez le nom de votre société" />
                    </Form.Item>
                </div>

                <div className="md:flex md:space-x-[30px] mb-[30px]">
                    <Form.Item className='flex flex-row-reverse justify-end items-start gap-x-2 md:w-[315px] mb-[30px] md:mb-0' onChange={(e:any)=>customHandleChange(1)} labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] inline-block mt-[1rem]" name="adresseProIdentique" label="Mon adresse professionnelle est identique à mon adresse personnelle">
                        <WOSInput type="checkbox" checked={values.adresseProIdentique} className="!h-auto" id="address-identique"/>
                    </Form.Item>
                    <Form.Item className='flex flex-row-reverse justify-end items-center gap-x-2 ' name="adresseProDifferente" onChange={(e:any)=>customHandleChange(2)} labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] inline-block mt-[.2rem]" label="Mon adresse professionnelle est différente">
                        <WOSInput type="checkbox" checked={values.adresseProDifferente} className="!h-auto" id="address-differente"/>
                    </Form.Item>
                </div>

                {values.adresseProDifferente  && (
                    <div className="mb-[30px]">
                        <Form.Item className='' name="adresseDomicile" onChange={handleChange} labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" label="Adresse professionnelle">
                            <Input type="text" className="!bg-[#F4F4F5] text-[15px] !m-auto" inputClassName="placeholder:text-[15px] placeholder:text-[#6F6F6F80]" placeholder="Entrez votre adresse professionnelle" />
                        </Form.Item>
                    </div>
                )}


                <div   className="mb-[30px]" >
                    <Form.Item className='' onChange={handleChange} name="numeroIdentification" labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" label="Numéro d’identification de la société">
                        <Input type="text" className="!bg-[#F4F4F5] text-[15px] !m-auto" inputClassName="placeholder:text-[15px] placeholder:text-[#6F6F6F80]" placeholder="Entrez le numéro d’identification de la société" />
                    </Form.Item>
                </div>

                <div className="mb-[30px]">
                    <Form.Item className='' onChange={handleChange} name="certificatImmatriculation" labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block " label={
                        <div>
                            <div className="text-[14px] font-dm-sans">Certificat d’immatriculation </div>
                            <span className="block text-[12px] font-dm-sans">(de - de 3 mois (ou équivalent), émis et certifié conforme par les autorités compétentes)</span>
                        </div>
                    }>  
                        {
                            ({field}:any)=>(
                                <div>
                                    <div className={`bg-red-400 rounded-full ring-2 ring-primary-blue`}>
                                        <FileUpload {...field} className="!bg-[#F4F4F5] text-[15px]" inputClassName="!bg-white !h-[45px] !m-0 w-full md:w-auto" placeholderClassName="hidden md:block md:ml-4"  accept="images/*" placeholder={(values?.certificatImmatriculation?.name || values?.certificatImmatriculation) || "Insérez le certificat d’immatriculation"}/> 
                                    </div>
                                </div>  
                            )
                        }
                    </Form.Item>
                </div>

                <div> 
                    <Form.Item className='' onChange={handleChange} name="justificatifIdentiteDirigeant" labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" label="Justificatif d’identité du dirigeant en cours de validité">
                        {
                            ({field}:any)=>(
                                <div>
                                    <div className={`bg-red-400 rounded-full`}>
                                        <FileUpload {...field} className="!bg-[#F4F4F5] text-[15px]" inputClassName="!bg-white !h-[45px] !m-0 w-full md:w-auto" placeholderClassName="hidden md:block md:ml-4"  accept="images/*" placeholder={(values.justificatifIdentiteDirigeant?.name || values.justificatifIdentiteDirigeant) || "Insérez le justificatif d’identité"}/>  
                                    </div>
                                </div>  
                            )
                        }
                    </Form.Item>
                </div>
            </div>


        </>
    )
    
}

const ProfileSettings = ()=>{
    const [profileImage, setProfileImage] = useState("/profile-worker-setting-profile.png");

    const { values, handleChange, handleBlur, errors, touched }:any = useFormikContext();

    const handleFile = (file:any) => {
        const reader:any = new FileReader();
        reader.onloadend = () => {
          setProfileImage(reader.result);
        };
        if (file) {
          reader.readAsDataURL(file);
        }
    };

    
    useEffect(()=>{
        console.log('profile settings', values)
    },[values])

    useEffect(()=>{
        console.log({values})
        if(!values.profile?.file){
            setProfileImage(values?.profile)
        }else{
            handleFile(values.profile.file)
        }
    },[values.profile])
    

    return (
        <>
            <div className="flex flex-col md:flex-row md:h-[255px] md:space-x-[34px] mb-[30px] ">
                <div className="md:w-[215px] flex-shrink-0 md:mr-[34px] mb-[40px] md:mb-0">
                    <div className=" font-semibold md:text-[20px] md:mb-[20px]">Réglages du Profil </div>
                    <Form.Item onChange={handleChange} className="relative md:h-[215px] w-[215px] md:w-full overflow-hidden  bg-cover" name="profile" style={{backgroundImage:`url(${profileImage})`, backgroundRepeat:'no-repeat'}}>
                        <FileUpload as={<ChangeProfileButton />} />
                    </Form.Item>
                </div>
                <div className="flex  w-full flex-col">
                    <div className="">
                        <div className="space-y-[20px]">
                            <Form.Item onChange={handleChange}  className='md:h-[70px]' labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" label="Civilité*"  name="civilite">
                                <Select options={[
                                    {label:"Madame", value:"Madame"},
                                    {label: "Monsieur", value: "Monsieur"}
                                ]} className="!bg-[#F4F4F5]   text-[15px]" style={{margin:'auto'}} placeholder="Madame" />
                            </Form.Item>

                            <Form.Item onChange={handleChange} className='md:h-[70px]' labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" label="Prénom*"  name="prenom">
                                <Input type="text" className="!bg-[#F4F4F5] text-[15px] !m-auto" placeholder="" />
                            </Form.Item>

                            <Form.Item onChange={handleChange} className='md:h-[70px]' labelClassName="font-dm-sans font-normal  text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block"  label="Nom*" name="nom">
                                <Input type="text" className="!bg-[#F4F4F5]  text-[15px] !m-auto" placeholder="" />
                            </Form.Item>
                        </div>
                    </div>
                </div>

            </div>

            <div className="mb-[50px]">
                <div className="md:grid md:grid-cols-2 gap-x-[20px] gap-y-[30px] space-y-[20px] md:space-y-0">

                    <Form.Item className='md:h-[70px]' onChange={handleChange} labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" name="email" label="Email*">
                        <Input type="text"  className="!bg-[#F4F4F5] text-[15px] !m-auto" inputClassName="placeholder:text-[15px]" placeholder="" />
                    </Form.Item>

                    <Form.Item className='md:h-[70px]' onChange={handleChange} labelClassName="font-dm-sans font-normal  text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" name="telephone"  label="Téléphone*">
                        <Input type="text" className="!bg-[#F4F4F5]  text-[15px] !m-auto" inputClassName="placeholder:text-[15px]"  placeholder="" />
                    </Form.Item>

                    <Form.Item className='md:h-[70px]' onChange={handleChange} labelClassName="font-dm-sans font-normal  text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" name="dateNaissance" label="Date de naissance*">
                        <Input type="text" className="!bg-[#F4F4F5]  text-[15px] !m-auto" inputClassName="placeholder:text-[15px]" placeholder="jj/mm/yyyy" />
                    </Form.Item>

                    <Form.Item className='md:h-[70px]' onChange={handleChange} labelClassName="font-dm-sans font-normal  text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" name="lieuNaissance" label="Lieu de naissance">
                        <Input type="text" className="!bg-[#F4F4F5]  text-[15px] !m-auto" inputClassName="placeholder:text-[15px]" placeholder="Entrez votre lieu de naissance" />
                    </Form.Item>

                    <Form.Item className='md:h-[70px]' onChange={handleChange} labelClassName="font-dm-sans font-normal  text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" name="nomUtilisateur"  label="Nom d’utilisateur*">
                        <Input type="text" className="!bg-[#F4F4F5]  text-[15px] !m-auto" inputClassName="placeholder:text-[15px]" placeholder="" />
                    </Form.Item>

                    <Form.Item className='md:h-[70px]' onChange={handleChange} labelClassName="font-dm-sans font-normal  text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" name="adresseComplete"  label="Adresse complète">
                        <Input type="text" className="!bg-[#F4F4F5]  text-[15px] !m-auto" inputClassName="placeholder:text-[15px]" placeholder="Entrez votre adresse complète" />
                    </Form.Item>

                    <div className="col-span-full">
                        <div className="flex flex-col md:flex-row w-full md:space-x-[20px] md:space-y-0 space-y-[20px]">
                            <Form.Item className='md:h-[70px] flex-1' onChange={handleChange} labelClassName="font-dm-sans font-normal  text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" name="codePostal"  label="Code postal">
                                <Input type="text" className="!bg-[#F4F4F5]  placeholder:text-[15px] !m-auto" inputClassName="placeholder:text-[15px]" placeholder="Code postal" />
                            </Form.Item>

                            <Form.Item className='md:h-[70px] flex-1' onChange={handleChange} labelClassName="font-dm-sans font-normal  text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" name="ville"  label="Entrez votre ville">
                                <Input type="text" className="!bg-[#F4F4F5]  text-[15px] !m-auto" inputClassName="placeholder:text-[15px]" placeholder="Entrez votre ville" />
                            </Form.Item>

                            <Form.Item className='md:h-[70px] flex-1' onChange={handleChange} labelClassName="font-dm-sans font-normal  text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" name="pays"  label="Pays*">
                                <Select options={countries} placeholder="Pays*" className="!bg-[#F4F4F5]   text-[15px]" inputClassName="placeholder:text-[15px] bg-[#F4F4F5]" style={{margin:'auto'}}  searchable/>
                            </Form.Item>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const Tarif = ()=>{
    const { handleChange, values, setFieldValue }:any =useFormikContext()

    const [currencies, setCurrencies]= useState([])

    const fetchCurrencies = async ()=>{
        try {
            const response :any = await _getCurrencies()
            console.log("oo", currencies.map((el:any)=>({label:`${el.name + '( ' + el.symbol + ' )'}`, value: `${el.name + '( ' + el.symbol + ' )'}`, rate: el.rate})))
            return response;
        } catch (error) {
            console.log({error})
        }
    }

    const convertLogic = (price:any, rate:number, to:any = "Euro( € )")=>{
        console.log({price, rate})
        return to === "Euro( € )" ? parseFloat(price) * rate : parseFloat(price) / rate 
    }

    useEffect(()=>{
        (async ()=>{
            let res = await fetchCurrencies()
            setCurrencies(res.map((el:any)=>({label:`${el.name + '( ' + el.symbol + ' )'}`, value: `${el.name + '( ' + el.symbol + ' )'}`, rate: el.rate})))
            
        })()
    },[])

    useEffect(()=>{
        setFieldValue('devise', currencies.find((el:any)=>el.label==="Euro( € )"))
    },[currencies])

    useEffect(()=>{
        if(values.prix1 && Object.values(values.devise || {}).length){
            setFieldValue('prix2', convertLogic(values?.prix1, values.devise?.rate, values.devise?.value))
        }else{
            setFieldValue('prix2', '')
        }
    },[values.prix1, values.devise])

    useEffect(()=>{
        if(values.prix1 && Object.values(values.devise || {}).length){
            setFieldValue('prix2', convertLogic(values?.prix1, values.devise?.rate, values.devise?.value))
        }
    },[values.devise])

    // console.log('prix2', values.devise)
    
    // console.log("top", currencies.find((el:any)=>el.label==="Euro( € )"))
    
    // console.log({currencies})

    return (
        <>
            <div className="my-[30px]">
                <div className="font-semibold text-[20px] text-primary-blue font-bricolage-grotesque mb-[30px]">Tarif</div>
                <div className="md:flex w-full md:space-x-[20px] md:space-y-0 space-y-[20px]">
                    <Form.Item className='flex-1' onChange={handleChange} name="devise">
                        <Select  options={currencies} keyValue=""  customValue={(data:any)=>data?.value?data.value: data} placeholder="Euro (€)" className="!bg-[#F4F4F5]   text-[15px]" inputClassName="placeholder:text-[15px] bg-[#F4F4F5]" style={{margin:'auto'}}  />
                    </Form.Item>

                    <Form.Item className='flex-1' onChange={handleChange} name="prix1">
                        <Input type="text" className="!bg-[#F4F4F5]  placeholder:text-[15px] !m-auto" inputClassName="placeholder:text-[15px]" placeholder="Entrez votre prix" />
                    </Form.Item>

                    <Form.Item className='flex-1' onChange={handleChange} name="prix2">
                        <Input type="text" readonly disabled className="!bg-[#F4F4F5]  text-[15px] !m-auto" inputClassName="placeholder:text-[15px]" placeholder="Prix en euro" />
                    </Form.Item>

                </div>
            </div>
        </>
    )
}

const DocumentATransmettre = ()=>{
    const {handleChange, values, errors}:any = useFormikContext()

    console.log({errors})
    return (
        <>
            <div className="mb-[30px]">
                <div className="font-semibold text-[20px] text-primary-blue font-bricolage-grotesque mb-[30px]">Documents à transmettre</div>
                <div className="md:h-[80px] !bg-[#F4F4F5] rounded-[10px] px-[21px] py-[20px] flex space-x-[23px] items-center ">
                    <img src="/info-profill-worker-settings.png" />
                    <div className="text-primary-blue font-dm-sans font-medium text-[15px]" >
                        Afin de pouvoir retirer de l’argent de votre E-Wallet, il est obligatoire de nous fournir les documents suivants
                    </div>
                </div>

                <div className="my-[30px]">
                    <Form.Item className='' onChange={handleChange} labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" name="attestation" label="Attestation de moins de dix jours signée par le représentant légal certifiant que le Worker est à jour de ses obligations légales et fiscales dans son pays d’implantation">
                        {
                            ({field}:any)=>(
                                <div>
                                    <div className={` ring-2 ring-primary-blue rounded-full `}>
                                        <FileUpload {...field} className="!bg-[#F4F4F5] text-[15px]" inputClassName="!bg-white !h-[45px] !m-0 w-full md:w-auto" placeholderClassName="hidden md:block md:ml-4"  accept="images/*" placeholder={values.attestation?.name || values.attestation || "Insérez votre attestation"}/> 
                                    </div>
                                </div>  
                            )
                        }
                    </Form.Item>
                    {
                        files['attestation']?.name ? (
                            <div className=" h-[2rem]  text-primary-blue text-sm flex items-center my-2 space-x-4">
                                <a href={files['attestation']?.url} className="!bg-[#eee] rounded-xl flex px-4 relative space-x-2">{files['attestation']?.name} <span className="bg-primary-blue text-white hidden absolute -top-2 -right-1 text-xs rounded-full h-4 w-4 flex cursor-pointer items-center justify-center">x</span> </a>
                            </div>

                        ):null
                    }
                </div>

                <div className="my-[30px]">
                    <Form.Item className='' onChange={handleChange} labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" name="rib" label="Votre RIB (facultatif)">
                        {
                            ({field}:any)=>(
                                <div>
                                    <div className={`bg-red-400 rounded-full ring-2 ring-primary-blue`}>
                                        <FileUpload {...field} className="!bg-[#F4F4F5] text-[15px]" inputClassName="!bg-white !h-[45px] !m-0 w-full md:w-auto" placeholderClassName="hidden md:block md:ml-4" accept="images/*" placeholder={values.rib?.name || values.rib || "Insérez votre RIB"}/>  
                                    </div>
                                </div>  
                            )
                        }
                    </Form.Item>
                    {
                        files['rib']?.name && (
                            <div className=" h-[2rem]  text-primary-blue text-sm flex items-center my-2 space-x-4">
                                <a href={files['rib']?.url} className="!bg-[#eee] rounded-xl flex px-4 relative space-x-2">{files['rib']?.name} <span className="bg-primary-blue text-white absolute hidden -top-2 -right-1 text-xs rounded-full h-4 w-4 flex cursor-pointer items-center justify-center">x</span> </a>
                            </div>
                        )
                    }
                </div>

                <div className="my-[30px]">
                    <Form.Item className='' onChange={handleChange} labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" label="Documents complémentaires (facultatif)" name="documentsComplementaires">
                        {
                            ({field}:any)=>(
                                <div>
                                    <div className={`bg-red-400 rounded-full ring-2 ring-primary-blue`}>
                                        <FileUpload {...field} className="!bg-[#F4F4F5] text-[15px]" inputClassName="!bg-white !h-[45px] !m-0 w-full md:w-auto" placeholderClassName="hidden md:block md:ml-4"  accept="images/*" placeholder={values.documentsComplementaires?.name || values.documentsComplementaires || "Insérez un document complémentaire"}/>  
                                    </div>
                                </div>  
                            )
                        }
                    </Form.Item>
                    {
                        files['documentsComplementaires']?.name &&
                        (
                            <div className=" h-[2rem]  text-primary-blue text-sm flex items-center my-2 space-x-4">
                                <a href={files['documentsComplementaires']?.url} className="!bg-[#eee] rounded-xl flex px-4 relative space-x-2">{files['documentsComplementaires']?.name} <span className="bg-primary-blue hidden text-white absolute -top-2 -right-1 text-xs rounded-full h-4 w-4 flex cursor-pointer items-center justify-center">x</span> </a>
                            </div>
                        )
                    }
                </div>

                <div>
                    <Form.Item className='flex flex-row-reverse justify-end items-start gap-x-2' onChange={handleChange} labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] inline-block mt-[.9rem]" label="J’autorise Wall Of Share à utiliser mon logo/image pour l’émission des factures de services" name="autorisationLogo" htmlFor="autorisation"> 
                        <WOSInput checked={values.autorisationLogo} type="checkbox" className="!h-auto" id="autorisation"/>
                    </Form.Item>
                </div>

                <div>
                    <Form.Item className='flex flex-row-reverse justify-end items-start gap-x-2' onChange={handleChange} labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] inline-block mt-[.9rem]" label="Je certifie que l’ensemble des documents et informations téléchargés sont authentiques, sincères et véritables." name="certificationAuthenticite" htmlFor="certification">
                        <WOSInput type="checkbox"  checked={values.certificationAuthenticite} className="!h-auto" id="certification"/>
                    </Form.Item>
                </div>
            </div>
            <ul className="list-disc list-inside p-0 m-0">
                {Object.values(errors).map((el:any)=>(<li className="text-sm text-red-400 my-2 ">{el}</li>))}
            </ul>
        </>
    )
}

let domainSkillMapping: any= {},ind:any,skillindex:any;

const Parcours = ()=>{
    const {handleChange,setFieldValue, values}:any = useFormikContext()

    const [domainsAndSkills, setDomainsAndSkills] = useState({
        domains:[],
        skills:[]
    })

    const [language, setLanguage] = useState([])

    const [isLoading, setisLoading] = useState(true)

    console.log({values},"parcours")


     useEffect(()=>{
        (async function(){
            try {

                let domains =  await _getDomains()
                let skills  = await _getSkills()
                let language = await _getLangs()


                console.log({language})



                setisLoading(false)

                setLanguage(language)

                domainSkillMapping = domains.reduce((acc:any, domain:any) => {
                const domainSkills = skills
                    .filter((skill:any) => skill.domain_id === domain.id)
            
                acc[domain.label] = domainSkills;
                return acc;
                }, {});

                setDomainsAndSkills({
                domains,
                skills:[]
                })


                
                
                // console.log({domains, skills, domainSkillMapping})
            } catch (error) {
            // console.log({error})
            }
        })()
    },[])

    console.log('domaine', values)

    const handleChangeDomainAndSkils = (value:any, index:number)=>{
        // console.log({index, skillindex, value})
        handleChange(value)
        for(let i=0;i<=skillindex;i++){
          setFieldValue(`domaineInfo[${index}].competences.${i}.nom`,'')
          setFieldValue(`domaineInfo[${index}].competences.${i}.experience`,'')
          setFieldValue(`domaineInfo[${index}].competences.${i}.niveau`,0)
        }
        setDomainsAndSkills((prev:any)=>({...prev, skills: domainSkillMapping[value.target.value.value] || []}))
    }

    useEffect(()=>{
        // console.log({domainsAndSkills, domainSkillMapping})
    },[domainsAndSkills])

    if(isLoading){
        return null
    }

    return (
        <>
            <FieldArray  name="domaineInfo" >
                {
                    ({push, remove, form})=>{
                        return (
                            <div className="mb-[30px]">
                                <div className="font-semibold text-[20px] text-primary-blue font-bricolage-grotesque mb-[30px]">Votre parcours</div>
                                {
                                    form.values.domaineInfo.map((val:any, index:number)=>{
                                        ind = index
                                        return (
                                            <div className="mb-[30px]">
                                                <div className="mb-[20px] relative">
                                                    {index ? <img src={CloseIcon} alt="close icon" className="absolute -top-0 z-50 transform translate-y-[2rem] cursor-pointer right-0" onClick={()=>remove(index)} />:null}
                                                    <Form.Item className='flex-1' label="Domaine" name={`domaineInfo[${index}].domaine`} onChange={(val:any)=>handleChangeDomainAndSkils(val, index)} labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block">
                                                        <Select  options={domainsAndSkills.domains} style={{margin: 'auto'}}  className="!bg-[#F4F4F5]  text-[15px] !m-auto" searchable keyValue="" customValue={(val:any)=>val?.value}   inputClassName="placeholder:text-[15px] bg-[#F4F4F5] placeholder:font-dm-sans" placeholder="Télé Opérateur" />
                                                    </Form.Item>
                                                </div>
                                                
                                                <FieldArray name={`domaineInfo.${index}.competences`}>
                                                    {
                                                        ({push, remove, form})=>{
                                                            return (
                                                                <>
                                                                    {
                                                                        val.competences.map((skill:any, skillIndex:any) => {    
                                                                            skillindex = skillIndex
                                                                            return (
                                                                                <div className="flex  md:space-x-[20px]  items-center   flex-wrap md:flex-nowrap justify-between  md:gap-x-0 mb-[20px]">
                                                                                    <div className="flex items-end flex-shrink-0 md:space-x-[20px] space-x-[20px] w-full md:w-auto">
                                                                                        {
                                                                                            !skillIndex?<button type="button" className="flex items-center justify-center w-[30px]  h-[30px] bg-[#6F6F6F] rounded-full text-white font-medium text-3xl" style={{aspectRatio: "1"}} onClick={()=>{
                                                                                                push({
                                                                                                    nom:"",
                                                                                                    experience:"",
                                                                                                    niveau:""
                                                                                                })
                                                                                            }}>
                                                                                                +
                                                                                            </button>: 
                                                                                            (
                                                                                               <button type="button" className="flex items-center justify-center w-[30px]  h-[30px] bg-[#6F6F6F] rounded-full text-white font-medium text-3xl" style={{aspectRatio: "1"}} onClick={()=>remove(skillIndex)}>
                                                                                                -
                                                                                              </button>
                                                                                            )
                                                                                        }
                                                                                        
                                                                                        <Form.Item className='w-full' onChange={handleChange} name={`domaineInfo[${index}].competences[${skillIndex}].nom`} labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" label="Compétence">
                                                                                            <Select options={domainsAndSkills.skills} resetDomainsAndSkills={()=>setDomainsAndSkills((prev:any)=>({...prev, skills: domainSkillMapping[val?.domaine?.value] || []}))} style={{margin: 'auto'}}  className="!bg-[#F4F4F5]  text-[15px] !m-auto w-full md:w-[342px]" searchable  inputClassName="placeholder:text-[15px] bg-[#F4F4F5] placeholder:font-dm-sans" keyValue="" customValue={(val:any)=>val?.value ? val.value: val} placeholder="Télé Opérateur" />
                                                                                        </Form.Item>
                                                                                    </div>
                
                                                                                    <div className='max-w-[98px] flex-shrink-0'>
                                                                                        <Form.Item className='' onChange={handleChange}  name={`domaineInfo[${index}].competences[${skillIndex}].experience`} labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block " label="Expérience">
                                                                                            <Input style={{width: '-webkit-fill-available', margin: 'auto'}} type="text" className="!bg-[#F4F4F5]  text-[15px] !m-auto " searchable  inputClassName="placeholder:text-[15px] bg-[#F4F4F5] placeholder:font-dm-sans" placeholder="3 ans" />
                                                                                        </Form.Item>
                                                                                    </div>
                
                                                                                    <div className="w-[130px] ">
                                                                                        <Form.Item className='' onChange={handleChange}  name={`domaineInfo[${index}].competences[${skillIndex}].niveau`} labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" label="Niveau">
                                                                                        <Level />
                                                                                        </Form.Item>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                
                                                                </>
                                                            )
                                                        }
                                                    }
                                                </FieldArray>
                                                <div className="mb-[30px] " />
                                                <Divider />
                                            </div>
                                        )
                                    })
                                }

                                <div className="my-[30px]">
                                    <button type="button" onClick={() =>{
                                        push({
                                            domaine: "", 
                                            competences: [{
                                                nom:"",
                                                experience: "",
                                                niveau: "",
                                            }], 
                                            experience: "",
                                            niveau: "",
                                        })
                                        console.log('ok')
                                    }
                                    } className="h-[50px] bg-primary-blue w-[179px]  rounded-[80px] font-normal font-dm-sans text-[15px] text-white">Ajouter un domaine</button>
                                </div>

                                
                            </div>
                        )
                    }

                }
            </FieldArray>

            <div className="mb-[30px]">
                <Form.Item className='' name="domaineFavoris" onChange={handleChange} labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" label="Domaine favori">
                    <Select options={values.domaineInfo.map((el:any)=>el.domaine)} defaultValue={values.domaineFavoris} style={{margin: 'auto'}}  keyValue={""} className="!bg-[#F4F4F5]  text-[15px] !m-auto " searchable  customValue={(values:any)=>values?.value} inputClassName="placeholder:text-[15px] bg-[#F4F4F5] placeholder:font-dm-sans" placeholder="Choisissez votre domaine favori" />
                </Form.Item>
            </div>

            <div className="">
                <Form.Item className='' onChange={handleChange} name="langues" labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" label="Langue(s) que vous maitrisez">
                    <Select options={language} style={{margin: 'auto'}}  className="!bg-[#F4F4F5]  text-[15px] !m-auto " searchable  multiple inputClassName="placeholder:text-[15px] !bg-[#F4F4F5] placeholder:font-dm-sans" placeholder="Langue(s) que vous maitrisez" />
                </Form.Item>
            </div>


            <div className="my-[30px]">
                <Form.Item className='' onChange={handleChange} name="audioPresentation" labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" label="Audio de présentation">
                    {
                        ({field}:any)=>(
                            <div>
                                <div className={`bg-red-400 rounded-full`}>
                                    <FileUpload {...field} className="!bg-[#F4F4F5] text-[15px]" inputClassName="!bg-white !h-[45px] !m-0 w-full md:w-auto" placeholderClassName="hidden md:block md:ml-4"  accept="audio/*" placeholder={values.audioPresentation?.name || values.audioPresentation || "Insérez votre audio de présentation"}/>  
                                </div>
                            </div>  
                        )
                    }
                </Form.Item>
            </div>

            <div className="mb-[30px]">
                <Form.Item className='' name="presentation" onChange={handleChange} labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] mb-[10px] mt-[5px] inline-block" label="Présentation (400 caractères maximum)">
                    <textarea defaultValue={values.presentation} className=" !bg-[#F4F4F5] block w-full h-[184px] resize-none rounded-[10px] p-[20px] outline-none" placeholder="Lorem ipsum dolor sit amet consectetur." />  
                </Form.Item>
            </div>
        </>
    )
}

const Status = ()=>{
    const [status, setStatus]= useState('Professionnel')
    const [freelanceStatus, setFreelanceStatus] = useState([])
    const {handleChange,setFieldValue, values}:any = useFormikContext()

    useEffect(()=>{
        (async ()=>{
        let res = await _getFreelanceStatus()
        console.log(res)
        setFreelanceStatus(res)
        })()
    },[])

    console.log({values})

    // useEffect(()=>{
    //     console.log({id: values.adresseProIdentique, diff: values.adresseProDifferente})
    //     if(values.adresseProDifferente){
    //         setFieldValue('adresseProIdentique', false)
    //         setFieldValue('adresseProDifferente', true)
    //     }

    //     if(values.adresseProIdentique && values.adresseProDifferente){
    //         if(!values.adresseProIdentique){
    //             setFieldValue('adresseProDifferente', false)
    //             setFieldValue('adresseProIdentique', true)
    //         }else{
    //             setFieldValue('adresseProDifferente', values.adresseProDifferente)
    //             setFieldValue('adresseProIdentique', false)
    //         }
    //     }
        
    //     // if(values.adresseProIdentique){
    //     //     setFieldValue('adresseProDifferente', false)
    //     //     setFieldValue('adresseProIdentique', true)
    //     // }
    // },[values.adresseProDifferente, values.adresseProIdentique])


    
    return (
        <>
            <div className="my-[30px]">
                <div className="font-semibold text-[20px] text-primary-blue font-bricolage-grotesque ">Votre statut</div>
                <div className="my-[30px]">
                    <div className="text-[#6F6F6F] font-dm-sans text-[14px] mb-[10px]">Indiquez votre statut</div>
                    <div className="mb-[30px]">
                        <Form.Item name="statut">
                            <Select  options={freelanceStatus} className="!bg-[#F4F4F5]  text-[15px]" defaultValue={freelanceStatus[0]} placeholderClassName="w-[40rem]" keyValue="" customValue={(val:any)=>val?.value?val.value:val} onChange={handleChange} placeholder="Votre statut" />
                        </Form.Item>
                    </div>

                    

                    {/* <div className="md:flex md:space-x-[30px] mb-[30px]">
                        <Form.Item className='flex flex-row-reverse justify-end items-start gap-x-2 md:w-[315px] mb-[30px] md:mb-0' onChange={(e:any)=>customHandleChange(1)} labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] inline-block mt-[1rem]" name="adresseProIdentique" label="Mon adresse professionnelle est identique à mon adresse personnelle">
                            <WOSInput type="checkbox" checked={values.adresseProIdentique} className="!h-auto" id="address-identique"/>
                        </Form.Item>
                        <Form.Item className='flex flex-row-reverse justify-end items-center gap-x-2 ' name="adresseProDifferente" onChange={(e:any)=>customHandleChange(2)} labelClassName="font-dm-sans font-normal text-[14px] text-[#6F6F6F] inline-block mt-[.2rem]" label="Mon adresse professionnelle est différente">
                            <WOSInput type="checkbox" checked={values.adresseProDifferente} className="!h-auto" id="address-differente"/>
                        </Form.Item>
                    </div> */}

                    {/* {JSON.stringify(values.statut)} */}

                    {/* <div className="md:grid grid-cols-2 gap-x-[20px] md:space-y-0 space-y-[20px]">
                        <div className="h-[50px] bg-[#F4F4F5] rounded-[80px] flex items-center pl-[21px] space-x-[10px]" >
                            <div className=" bg-white h-3.5 w-3.5 flex items-center justify-center  rounded-full border border-primary-blue ">
                               {status === "Professionnel" && (<div className="h-2 w-2 bg-primary-blue rounded-full text-white"></div>)} 
                            </div>
                            <div className="font-dm-sans font-normal text-[15px] text-primary-blue cursor-pointer" onClick={()=>setStatus('Professionnel')}>Professionnel</div>
                        </div>
                        
                        <div className="h-[50px] bg-[#F4F4F5] rounded-[80px] flex items-center pl-[21px] space-x-[10px]">
                            <div className=" bg-white h-3.5 w-3.5 flex items-center justify-center  rounded-full border border-primary-blue ">
                                {status === "Particulier" && (<div className="h-2 w-2 bg-primary-blue rounded-full text-white"></div>)} 
                            </div>
                            <div className="font-dm-sans font-normal text-[15px] text-primary-blue cursor-pointer" onClick={()=>setStatus('Particulier')}>Particulier</div>
                        </div>
                    </div> */}
                </div>

                {[1,2].includes(parseInt(values?.statut?.id,10)) ? <ProfessionalStatus />:<ParticularStatus />}
            </div>
        </>
    )
}